import { Dialog, GenericSuspense, useUrlParamsValueToString, useTranslation } from "@bsm/component"
import { Outlet, useNavigate, useParams } from "react-router-dom"
import { useBankQuery } from "../hooks/useBankQuery"
import { BankDetails } from "../components/BankDetails"

export const BankDetailsContainer = () => {

    const { bankId } = useParams()
    const urlParams = useUrlParamsValueToString()
    const { data } = useBankQuery(bankId ? parseInt(bankId) : undefined, true)
    const navigate = useNavigate()
    const t = useTranslation()

    return (
        <Dialog open title={'Bank details'} onClose={() => navigate(`..?${urlParams}`)}>
            <BankDetails {...data} />
            <GenericSuspense>
                <Outlet />
            </GenericSuspense>
        </Dialog>
    )
}
